/* eslint-disable default-param-last */
import { __, assocPath, compose, filter, identity, keys, lensPath, map, over, prop } from 'ramda';
import { deepMerge } from "../utils";
var subActionReducers = {
  set: function set() {
    return function (_state, action) {
      return action.payload;
    };
  },
  update: function update(defaultState) {
    return function () {
      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
      var action = arguments.length > 1 ? arguments[1] : undefined;
      return deepMerge(state, action.payload);
    };
  },
  reset: function reset(defaultState) {
    return function () {
      return defaultState;
    };
  }
};

// todo add checks for unsupported actions
export var generateReducerForAction = function generateReducerForAction(action) {
  var reducerList = compose(map(function (key) {
    return function (state, reduxPlainAction) {
      if (reduxPlainAction.type === action.types[key]) {
        return over(lensPath(action.path), function (substate) {
          return subActionReducers[key](action.defaultState)(substate, reduxPlainAction);
        }, state);
      }
      return state;
    };
  }), filter(prop(__, action.types)), keys)(subActionReducers);
  reducerList.push(function (state, reduxPlainAction) {
    if (reduxPlainAction.type === "".concat(action.name, "__initialize")) {
      return assocPath(action.path, action.defaultState, state);
    }
    return state;
  });
  return reducerList.reduce(function (result, value) {
    return function (state, localAction) {
      return value(result(state, localAction), localAction);
    };
  }, identity);
};